export default (function($) {

    var socialShare = function(url, type, options) {
        if (typeof url === 'object') {
            options = url;
            url = window.location.href;
        }

        var url_encoded = encodeURIComponent(url);

        var shareURLs = {
            'twitter': 'https://twitter.com/intent/tweet?url=' + url_encoded,
            'facebook': 'https://facebook.com/sharer.php?u=' + url_encoded,
            'googlePlus': 'https://plus.google.com/share?url=' + url_encoded,
            'pi': 'https://pinterest.com/share?url=' + url_encoded,
        };

        if (type === 'twitter') {

            if (options.text) {
                shareURLs['twitter'] += '&text=' + encodeURIComponent(options.text);
            }

            if (options.via) {
                shareURLs['twitter'] += '&via=' + encodeURIComponent(options.via);
            }

        }

        return shareURLs[type]

    };

    $('.single__header').on( 'click', '#plustext', function() {
        curSize = parseInt($('.single__content--wrp').css('font-size')) + 2;
        if (curSize <= 20) $('.single__content--wrp').animate({'font-size': curSize});
    });
    $('.single__header').on( 'click', '#minustext', function() {
        curSize = parseInt($('.single__content--wrp').css('font-size')) - 2;
        if (curSize >= 12) $('.single__content--wrp').animate({'font-size': curSize});
    });

    $('a.share').on( 'click', function(e) {
        e.preventDefault();
        var type = $(this).data('type');
        var href = $(this).attr('href');
        var options = {
            via: $(this).data('via') ? $(this).data('via') : null,
            text: $(this).data('text') ? $(this).data('text') : null
        };

        var url = socialShare(href, type, options),
            w = 500,
            h = 400,
            left = (screen.width / 2) - (w / 2),
            top = (screen.height / 2) - (h / 2);

        window.open(url, 'Social Share', 'toolbar=no, location=no, directories=no, status=no,' +
            ' menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
    });

    $(document).ready(function() {
        $('.single__header').on('click', '#print', function(event) {
            $(".printable").printThis();
        });
    });
})(jQuery);
